<template>
  <form class="other-relationship-editor" @submit.prevent="submit">
    <div class="other-relationship-editor__grid">
      <div class="other-relationship-editor__field">
        <label class="other-relationship-editor__label" for="other-relationship-rut">Rut</label>
        <input
          id="other-relationship-rut"
          v-model.trim="form.rut"
          class="other-relationship-editor__input"
          type="text"
          placeholder="12.345.678-9"
        >
      </div>

      <div class="other-relationship-editor__field">
        <label class="other-relationship-editor__label" for="other-relationship-name">Nombre</label>
        <input
          id="other-relationship-name"
          v-model.trim="form.name"
          class="other-relationship-editor__input"
          type="text"
          placeholder="Nombre de la persona"
        >
      </div>

      <div class="other-relationship-editor__field">
        <label class="other-relationship-editor__label" for="other-relationship-type">Tipo de relacion</label>
        <input
          id="other-relationship-type"
          v-model.trim="form.relationship_type"
          class="other-relationship-editor__input"
          type="text"
          placeholder="Apoderado, asesor, familiar..."
        >
      </div>

      <div class="other-relationship-editor__field">
        <label class="other-relationship-editor__label" for="other-relationship-phone">Telefono</label>
        <input
          id="other-relationship-phone"
          v-model.trim="form.phone"
          class="other-relationship-editor__input"
          type="tel"
          placeholder="+56 9 ..."
        >
      </div>

      <div class="other-relationship-editor__field">
        <label class="other-relationship-editor__label" for="other-relationship-email">Email</label>
        <input
          id="other-relationship-email"
          v-model.trim="form.email"
          class="other-relationship-editor__input"
          type="email"
          placeholder="correo@empresa.cl"
        >
      </div>

      <div class="other-relationship-editor__field other-relationship-editor__field--full">
        <label class="other-relationship-editor__label" for="other-relationship-notes">Observaciones</label>
        <textarea
          id="other-relationship-notes"
          v-model.trim="form.notes"
          class="other-relationship-editor__textarea"
          rows="4"
          placeholder="Contexto adicional de la relación"
        ></textarea>
      </div>
    </div>

    <p v-if="error" class="other-relationship-editor__error">{{ error }}</p>

    <footer class="other-relationship-editor__actions">
      <button class="other-relationship-editor__ghost" type="button" :disabled="saving" @click="$emit('cancel')">
        Cancelar
      </button>

      <button class="other-relationship-editor__primary" type="submit" :disabled="saving">
        {{ saving ? 'Guardando...' : submitLabel }}
      </button>
    </footer>
  </form>
</template>

<script>
import companyPeopleService from '@/services/company/companyPeople.service'

const defaultForm = () => ({
  id: null,
  rut: '',
  name: '',
  relationship_type: '',
  phone: '',
  email: '',
  notes: ''
})

export default {
  name: 'OtherRelationshipEditor',
  props: {
    value: {
      type: Object,
      default: null
    },
    companyId: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      form: defaultForm(),
      saving: false,
      error: ''
    }
  },
  computed: {
    submitLabel () {
      return this.form.id ? 'Guardar cambios' : 'Crear relacion'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        this.form = {
          ...defaultForm(),
          ...(newValue || {})
        }
      }
    }
  },
  methods: {
    validate () {
      if (!this.form.rut) {
        this.error = 'El rut es obligatorio.'
        return false
      }

      if (!this.form.name) {
        this.error = 'El nombre es obligatorio.'
        return false
      }

      if (!this.form.relationship_type) {
        this.error = 'El tipo de relacion es obligatorio.'
        return false
      }

      this.error = ''
      return true
    },
    normalizePayload () {
      return {
        id: this.form.id,
        company_id: Number(this.companyId),
        rut: this.form.rut ? this.form.rut.replace(/\./g, '').trim() : '',
        name: this.form.name,
        relationship_type: this.form.relationship_type,
        phone: this.form.phone,
        email: this.form.email,
        notes: this.form.notes
      }
    },
    async submit () {
      if (!this.validate()) return

      this.saving = true
      this.error = ''

      try {
        const payload = this.normalizePayload()
        const saved = this.form.id
          ? await companyPeopleService.updateOtherRelationship(payload)
          : await companyPeopleService.createOtherRelationship(payload)

        this.$emit('saved', saved)
      } catch (err) {
        this.error = err?.message || 'No fue posible guardar la relacion.'
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.other-relationship-editor {
  display: grid;
  gap: 1rem;
}

.other-relationship-editor__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}

.other-relationship-editor__field {
  display: grid;
  gap: 0.38rem;
}

.other-relationship-editor__field--full {
  grid-column: span 2;
}

.other-relationship-editor__label {
  color: #4b3b2f;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.other-relationship-editor__input,
.other-relationship-editor__textarea {
  padding: 0.7rem 0.85rem;
  border: 1px solid rgba(102, 81, 57, 0.14);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.76);
  color: #241c16;
}

.other-relationship-editor__input {
  min-height: 2.9rem;
}

.other-relationship-editor__textarea {
  resize: vertical;
}

.other-relationship-editor__error {
  margin: 0;
  color: #a24444;
  font-size: 0.9rem;
}

.other-relationship-editor__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.55rem;
}

.other-relationship-editor__ghost,
.other-relationship-editor__primary {
  min-height: 2.65rem;
  padding: 0 0.95rem;
  border-radius: 999px;
}

.other-relationship-editor__ghost {
  border: 1px solid rgba(102, 81, 57, 0.12);
  background: rgba(255, 255, 255, 0.72);
  color: #392d22;
}

.other-relationship-editor__primary {
  border: 0;
  background: linear-gradient(135deg, #251d16 0%, #4c3c2d 100%);
  color: #f7f0e5;
}

@media (max-width: 640px) {
  .other-relationship-editor__grid {
    grid-template-columns: 1fr;
  }

  .other-relationship-editor__field--full {
    grid-column: span 1;
  }

  .other-relationship-editor__actions {
    flex-direction: column;
  }
}
</style>
